"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6 flex-wrap justify-center">
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded-md" />
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded-md" />
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex gap-6 flex-wrap justify-center">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] text-sm font-medium">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const socialLinks = [{
    name: "Facebook",
    icon: Facebook,
    url: "https://facebook.com"
  }, {
    name: "Twitter",
    icon: Twitter,
    url: "https://twitter.com"
  }, {
    name: "Instagram",
    icon: Instagram,
    url: "https://instagram.com"
  }, {
    name: "LinkedIn",
    icon: Linkedin,
    url: "https://linkedin.com"
  }];
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark py-12 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col items-center gap-8">
          <MenuProvider menu_id="14" className="w-full">
            <FooterMenuConsumer />
          </MenuProvider>

          <div className="flex gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.name} to={social.url} data-index={i} newTab className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5" aria-label={social.name}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          <p className="text-center text-sm text-foreground">
            &copy; {new Date().getFullYear()} MT4 Drones Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}